import InputSmall from "../../common/InputSmall";
import SearchWhite from "../../common/SearchWhite";
import Select from "../../common/Select";
import Checkbox from "../../common/Checkbox";
import ButtonPrimary from "../../buttons/ButtonPrimary";
import clear from "../../../assets/clear.png";
import upload from "../../../assets/upload-picture.png";

const AddParcelForm = ({ handleShowModal }) => {
  return (
    <div className="grid xl:grid-cols-[auto_319px] py-16 px-6 ">
      <div className="flex flex-col items-start gap-6">
        <div className="w-full grid grid-cols-1 py-3 px-6 gap-4 bg-gray-100 border border-gray-200 rounded-xl lg:grid-cols-2">
          <InputSmall text="გზავნილის კოდი" />
          <InputSmall text="ოთახის ნომერი" />
        </div>
        <div className="w-full grid grid-cols-1 py-3 px-6 gap-4 bg-gray-100 border border-gray-200 rounded-xl md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5">
          <InputSmall text="წონა" />
          <InputSmall text="რაოდენობა" />
          <InputSmall text="სიგრძე (სმ)" />
          <InputSmall text="სიგანე (სმ)" />
          <InputSmall text="სიმაღლე (სმ)" />
        </div>
        <div className="w-full grid grid-cols-1 gap-4 rounded-xl lg:grid-cols-2 xl:grid-cols-3">
          <SearchWhite />
          <Select options={[]} text="Goods type" />
          <Select options={[]} text="Sub type" />
        </div>
        <div className="w-full grid grid-cols-1 py-3 px-6 gap-4 bg-gray-100 border border-gray-200 rounded-xl lg:grid-cols-2">
          <div className="text-xs text-blue-2 font-medium bg-blue-2/15 flex justify-start items-center rounded-lg py-2 px-3">
            ჯამური რაოდენობა
          </div>
          <div className="text-xs text-blue-2 font-medium bg-blue-2/15 flex justify-start items-center rounded-lg py-2 px-3">
            ჯამური წონა
          </div>
        </div>
        <div className="w-full grid grid-cols-1 py-5 px-6 gap-4 bg-gray-100 border border-gray-200 rounded-xl lg:grid-cols-2">
          <div className="flex justify-between items-center gap-5 pr-10">
            <div className="flex justify-center items-center gap-2">
              <Checkbox checked={true} />
              <span className="text-xs text-gray-400">Screened</span>
            </div>
            <div className="flex justify-center items-center gap-2">
              <Checkbox checked={true} />
              <span className="text-xs text-gray-400">Diplomatic</span>
            </div>
            <div className="flex justify-center items-center gap-2">
              <Checkbox checked={true} />
              <span className="text-xs text-gray-400">Express</span>
            </div>
          </div>
          <div className="flex items-center justify-between pl-3 gap-4">
            <p className="text-sm font-medium text-gray-1">
              Contain lithium batteries?
            </p>
            <div className="flex justify-between items-center gap-5 max-w-40 w-full">
              <div className="flex justify-center items-center gap-2">
                <Checkbox checked={true} />
                <span className="text-xs text-gray-400">Yes</span>
              </div>
              <div className="flex justify-center items-center gap-2">
                <Checkbox checked={true} />
                <span className="text-xs text-gray-400">No</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-9 flex flex-col justify-between">
        <div className="flex flex-col items-center w-full gap-5">
          <button className="w-full p-1.5 flex justify-center items-center gap-4 rounded-xl border border-red-300 transition-all duration-300 hover:border-red-500">
            <img src={clear} alt="clear" />
            <span className=" text-base font-medium text-blue-1">Clear</span>
          </button>
          <button
            onClick={handleShowModal}
            className="w-full p-1.5 flex justify-center items-center gap-4 rounded-xl border border-dashed border-blue-300 transition-all duration-300 hover:border-solid"
          >
            <img src={upload} alt="" />
            <span className=" text-base font-medium text-blue-1">
              Upload Image
            </span>
          </button>
        </div>
        <ButtonPrimary>შენახვა</ButtonPrimary>
      </div>
    </div>
  );
};

export default AddParcelForm;
